module.exports = __webpack_public_path__ + "assets/images/chef_03_adf31a9209376f773357b4fdb8397a08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/chef_03.png
// module id = 185
// module chunks = 0